import { Breadcrumbs, Typography, Link } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { BackButton } from "../../../../../common/components/back_button";
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar";
import { PopperButton } from "../../../../../common/components/popper_button";
import { useColetaPrecosCadastroViewModel } from "../../viewModels/coleta_precos_cadastro_view_model";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DefaultFormDownloadInput } from "../../../../../common/components/default_form_download_input";
import { ColetaPrecoFornecedorModal } from "./components/coleta_preco_fornecedor_modal";
import { ColetaPrecoFornecedorViewer } from "./components/coleta_preco_fornecedor_viewer";
import { useMemo } from "react";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultFormDatePickerInput } from "../../../../../common/components/default_form_date_picker_input";
import { GenerateColetaPrecoFornecedorColumnDefinition } from "./columns";
import { CopyColetaPrecoFornecedorModal } from "./components/copy_coleta_preco_fornecedor_modal";
import { ConfigurarPagamentoModal } from "./components/configurar_pagamento_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { FornecedorDrawer } from "../../../../../common/components/drawers_api/drawers/fornecedor_drawer";
import { DefaultFormMultiAutocomplete } from "../../../../../common/components/default_form_multi_autocomplete";
import { EmailModal } from "../../../../../common/components/email_modal";
import { AprovadoresColetaPrecoModal } from "./components/aprovadores_coleta_preco_modal";

import AlertError from "../../../../../common/components/alert_error";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import dayjs from "dayjs";

/**
 * ColetaPrecosCadastro
 */

export const ColetaPrecosCadastro = () => {
  const viewModel = useColetaPrecosCadastroViewModel();

  const coletaPrecoFornecedorColumnDefinition = useMemo(() => {
    return GenerateColetaPrecoFornecedorColumnDefinition({
      status: viewModel.coletaPreco !== null ? viewModel.coletaPreco.status : null,
      onQuantidadeColetaChange: viewModel.handleQuantidadeColetaChange,
      onValorUnitarioChange: viewModel.handleValorUnitarioChange,
      onObservacaoChange: viewModel.handleObservacaoChange,
      onActionEditar: viewModel.handleEditarColetaProdutoServico,
      onActionDelete: viewModel.handleDeleteColetaProdutoServicoSubmit,
    });
  }, [
    viewModel.coletaPreco,
    viewModel.handleQuantidadeColetaChange,
    viewModel.handleValorUnitarioChange,
    viewModel.handleObservacaoChange,
    viewModel.handleEditarColetaProdutoServico,
    viewModel.handleDeleteColetaProdutoServicoSubmit,
  ]);

  return (
    <>

      {/**
        * PageTopBar
        */}

      <form onSubmit={viewModel.handleSubmit}>
        <PageTopBar>
          <TwoSlotLayout
            leftSlot={
              <FormRadioGroupInput
                name='status'
                options={viewModel.statusOptions}
                reactHookForm={viewModel.hookForm}
                onValueChange={viewModel.handleStatusChangeSubmit}
              />
            }
            rightSlot={
              <div className="flex flex-row gap-2">
                {
                  (viewModel.idColetaPreco && viewModel.coletaPreco) &&
                  <div className="w-[160px] ">
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={() => viewModel.handleGenerateReport()}>
                      Relatório de cotação
                    </PrimaryButton>
                  </div>
                }
                {
                  (viewModel.idColetaPreco
                    && viewModel.coletaPreco
                    && viewModel.coletaPreco.idOrdemCompra
                    && viewModel.coletaPreco.status === 2) &&
                  <>
                    <div className="w-[14rem]">
                      <PrimaryButton
                        buttonColor='secondary'
                        startIcon={<DynamicIcon nameIcon="ShoppingCart" size={25} />}
                        onMouseDown={e => {
                          if (e.button === 1) {
                            viewModel.handleIrParaOrdemCompra(true);
                          } else {
                            viewModel.handleIrParaOrdemCompra(e.ctrlKey);
                          }
                          e.preventDefault();
                        }}>
                        Ir Ordem de Compra {viewModel.coletaPreco.nrOrdemCompra}
                      </PrimaryButton>
                    </div>
                  </>
                }
                {
                  (viewModel.idColetaPreco
                    && viewModel.coletaPreco
                    && viewModel.coletaPreco.status === 3
                    && viewModel.coletaPreco.idOrdemCompra === null) &&
                  <>
                    <div className="w-[14rem]">
                      <PrimaryButton
                        buttonColor='red'
                        startIcon={<DynamicIcon nameIcon="ShoppingCart" size={25} />}
                        onClick={viewModel.handleGerarOrdemCompraSubmit}>
                        Gerar Ordem de Compra
                      </PrimaryButton>
                    </div>
                  </>
                }
                {
                  (viewModel.status === 1 || viewModel.status === 4) &&
                  <>
                    <div className="w-[10rem]">
                      <PrimaryButton
                        startIcon={<DynamicIcon nameIcon="ThumbUp" size={25} className="text-white" />}
                        onMouseDown={e => {
                          viewModel.handleAprovarColetaPrecoFornecedorSubmit();
                          e.preventDefault();
                        }}>
                        Aprovar Coleta
                      </PrimaryButton>
                    </div>
                  </>
                }
                <div className="w-[115px]">
                  <PopperButton
                    buttonLabel='Opções'
                    buttonColor='yellow'
                    options={viewModel.buttonOptions}
                    onSelect={viewModel.handlePopperActions}
                  />
                </div>

                <BackButton
                  onClick={viewModel.handleBack}
                />
              </div>
            }
          />
        </PageTopBar>

        {/**
        * Page
        */}
        <div className="flex w-full gap-2 flex-col p-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Compras
            </Link>
            <Link underline="hover" color="inherit" component='span'>
              <LinkTo to="/ColetaPrecos_lista" >
                Coleta de Preços
              </LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Coleta de Preços
            </Typography>
          </Breadcrumbs>

          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-col gap-2">
              <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                <div className="flex gap-2 items-center w-full">
                  <h1 className="text-3xl font-medium text-black dark:text-white">
                    Cadastro de Coleta de Preços
                  </h1>
                  <RefreshButton onClick={viewModel.handleReload} />
                </div>
              </div>
            </div>

            <div>
              {
                ((!viewModel.atributoCompra || viewModel.atributoCompra.exibirDataAprovacaoColetaPreco) && viewModel.coletaPreco && viewModel.coletaPreco.funcionarioAprovador) &&
                <div className="text-xs text-red-500">
                  <div className="flex flex-row gap-1">
                    <span className="font-bold">Aprovado por:</span>
                    <span>{viewModel.coletaPreco.funcionarioAprovador}</span>
                  </div>
                  <div className="flex flex-row gap-1">
                    <span className="font-bold">Data Aprovação: </span>
                    <span>
                      {
                        viewModel.coletaPreco.dataAprovacao !== null
                          ? dayjs(viewModel.coletaPreco.dataAprovacao).local().format("DD/MM/YYYY")
                          : null
                      }
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload}
                  />
                </div>
              ) : (
                <>
                  <div className="w-full flex flex-col gap-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white p-4">
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-4 gap-x-2 mt-2">
                      <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                        <DefaultFormInput
                          name='nro'
                          label='Nº da coleta'
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />
                        {
                          (viewModel.atributoCompra && viewModel.atributoCompra.exibirDataCadastro) &&
                          <DefaultFormDatePickerInput
                            name='dataCadastro'
                            label='Data de Cadastro'
                            readOnly={true}
                            reactHookForm={viewModel.hookForm}
                          />
                        }
                      </div>

                      <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                        <DefaultFormAutocomplete
                          name='idRequisicaoCompra'
                          label='Nº da Requisição'
                          options={viewModel.requisicoesComprasDropdown}
                          getOptionKey={x => x.idRequisicaoCompra}
                          getOptionLabel={x => x.descricao}
                          readOnly={
                            viewModel.coletaPreco !== null && viewModel.coletaPreco.idRequisicaoCompra !== null &&
                            viewModel.coletaPreco.idRequisicaoCompra > 0
                          }
                          required={true}
                          reactHookForm={viewModel.hookForm}
                          onChangeValue={viewModel.handleNroRequisicaoCompraChange}
                        />

                        <DefaultFormDatePickerInput
                          name='dataColeta'
                          label='Data da Coleta'
                          readOnly={viewModel.coletaPreco !== null && viewModel.coletaPreco.status === 2}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                        <DefaultFormAutocomplete
                          name='centroCusto'
                          label='Centro de Custo'
                          options={viewModel.centroCustosDropdown}
                          getOptionKey={x => x.id}
                          getOptionLabel={x => x.title}
                          readOnly={true}
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormAutocomplete
                          name='idSubconta'
                          label='Subconta'
                          readOnly={viewModel.coletaPreco !== null && viewModel.coletaPreco.status === 2}
                          options={viewModel.subcontasDropdown}
                          getOptionKey={x => x.id}
                          getOptionLabel={x => x.title}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="w-full col-span-1 md:col-span-2 xl:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-2">
                        <DefaultFormAutocomplete
                          name='idFuncionarioComprador'
                          label='Comprador'
                          getOptionDisabled={x => !x.canBeSelected}
                          readOnly={viewModel.coletaPreco !== null && viewModel.coletaPreco.status === 2}
                          options={viewModel.funcionariosCompradorDropdown}
                          getOptionKey={x => x.idFuncionario}
                          getOptionLabel={x => x.nome}
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormMultiAutocomplete
                          name='idFuncionarioAprovadores'
                          label='Resp. Aprovação'
                          readOnly={viewModel.coletaPreco !== null && viewModel.coletaPreco.status === 2}
                          options={viewModel.funcionariosAprovadorDropdown}
                          getOptionDisabled={x => !x.canBeSelected}
                          getOptionKey={x => x.idFuncionario}
                          getOptionLabel={x => x.nomeFuncionario}
                          reactHookForm={viewModel.hookForm}
                        />

                        {/*
                        <DefaultFormAutocomplete
                          name='idFuncionarioAprovado'
                          label='Resp. Aprovação'
                          getOptionDisabled={x => !x.canBeSelected}
                          readOnly={viewModel.coletaPreco !== null && viewModel.coletaPreco.status === 2}
                          options={viewModel.funcionariosAprovadorDropdown}
                          getOptionKey={x => x.idFuncionario}
                          getOptionLabel={x => x.nome}
                          reactHookForm={viewModel.hookForm}
                        />
                        */}
                      </div>
                    </div>

                    {
                      (viewModel.idColetaPreco && viewModel.coletaPreco) &&
                      <div className="w-full flex flex-row items-end">
                        {
                          viewModel.coletaPreco.requisicaoCompraFinalizada ?
                            (
                              <div className="w-full flex flex-col justify-center items-end gap-1">
                                <div className="w-[12rem]">
                                  <PrimaryButton
                                    buttonColor='secondary'>
                                    Requisição Finalizada
                                  </PrimaryButton>
                                </div>
                                <span className="text-sm text-red-500">
                                  &nbsp;
                                </span>
                              </div>
                            ) : (
                              <div className="w-full flex flex-col justify-center items-end gap-1">
                                <div className="flex flex-row gap-2">
                                  {
                                    (viewModel.coletaPreco && viewModel.coletaPreco.status === 1) &&
                                    <div className="w-[12rem]">
                                      <PrimaryButton
                                        buttonColor='secondary'
                                        startIcon={<DynamicIcon nameIcon="EmailOutlined" size={25} />}
                                        onClick={() => viewModel.handleEmailAprovacaoOpenState(true)}>
                                        Solicitar Aprovação
                                      </PrimaryButton>
                                    </div>
                                  }

                                  <div className="w-[12rem]">
                                    <PrimaryButton
                                      buttonColor='secondary'
                                      startIcon={<DynamicIcon nameIcon="ShoppingCart" size={25} />}
                                      onClick={viewModel.handleFinalizarRequisicao}>
                                      Finalizar Requisição
                                    </PrimaryButton>
                                  </div>
                                </div>
                                <span className="text-sm text-red-500">
                                  Finalizar a requisição, apenas quando não precisar comprar mais nenhum item.
                                </span>
                              </div>
                            )
                        }
                      </div>
                    }
                  </div>


                  <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-4 gap-x-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    <div className="w-full flex flex-col gap-2">
                      <h1 className="font-bold text-xl">Anexar documentos</h1>
                      <div className="w-[45rem] flex flex-col gap-4 ps-[5rem] mt-[2rem] mb-[2rem]">
                        <DefaultFormDownloadInput
                          name='arquivo1'
                          nameLimparFlag='limparArquivo1'
                          saving={viewModel.saving}
                          filename={viewModel.coletaPreco?.nomeArquivo1 ?? null}
                          maxFilenameSize={70}
                          reactHookForm={viewModel.hookForm}
                          onDeleteFile={() => viewModel.handleDeleteFile(1)}
                          onDownloadFile={(_) => {
                            if (viewModel.coletaPreco && viewModel.coletaPreco.nomeArquivo1) {
                              viewModel.handleDownloadFile(1, viewModel.coletaPreco.nomeArquivo1);
                            }
                          }}
                        />

                        <DefaultFormDownloadInput
                          name='arquivo2'
                          nameLimparFlag='limparArquivo2'
                          saving={viewModel.saving}
                          filename={viewModel.coletaPreco?.nomeArquivo2 ?? null}
                          maxFilenameSize={70}
                          reactHookForm={viewModel.hookForm}
                          onDeleteFile={() => viewModel.handleDeleteFile(2)}
                          onDownloadFile={(_) => {
                            if (viewModel.coletaPreco && viewModel.coletaPreco.nomeArquivo2) {
                              viewModel.handleDownloadFile(2, viewModel.coletaPreco.nomeArquivo2);
                            }
                          }}
                        />

                        <DefaultFormDownloadInput
                          name='arquivo3'
                          nameLimparFlag='limparArquivo3'
                          saving={viewModel.saving}
                          filename={viewModel.coletaPreco?.nomeArquivo3 ?? null}
                          maxFilenameSize={70}
                          reactHookForm={viewModel.hookForm}
                          onDeleteFile={() => viewModel.handleDeleteFile(3)}
                          onDownloadFile={(_) => {
                            if (viewModel.coletaPreco && viewModel.coletaPreco.nomeArquivo3) {
                              viewModel.handleDownloadFile(3, viewModel.coletaPreco.nomeArquivo3);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="w-full flex flex-col gap-2 mt-4">
                    {
                      (viewModel.coletaPrecoFornecedores && viewModel.coletaPrecoFornecedores.length > 0) &&
                      <ColetaPrecoFornecedorViewer
                        loading={viewModel.loading}
                        saving={viewModel.saving}
                        status={viewModel.coletaPreco !== null ? viewModel.coletaPreco.status : null}
                        colunmnDefinitions={coletaPrecoFornecedorColumnDefinition}
                        coletaPrecoFornecedores={viewModel.coletaPrecoFornecedores}
                        coletaProdutosServicos={viewModel.coletaProdutosServicos}
                        coletaPrecoFornecedor={viewModel.selectedColetaPrecoFornecedor}
                        subTotal={viewModel.subTotal}
                        total={viewModel.total}
                        selectedColetaPrecoFornecedorIdx={viewModel.selectedColetaPrecoFornecedorIdx}
                        onColetaPrecoFornecedorChange={viewModel.handleColetaPrecoFornecedorChange}
                        onImpostoChange={viewModel.handleImpostoChange}
                        onFreteChange={viewModel.handleFreteChange}
                        onDescontoChange={viewModel.handleDescontoChange}
                        onAcrescimoChange={viewModel.handleAcrescimoChange}
                        onDataEntregaChange={viewModel.handleDataEntregaChange}
                        onPrazoEntregaChange={viewModel.handlePrazoEntregaChange}
                        onCondicoesPagamentoChange={viewModel.handleCondicoesPagamentoChange}
                        onObservacoesChange={viewModel.handleObservacoesChange}
                        onCopyColetaPrecoFornecedor={viewModel.handleCopyColetaPrecoFornecedor}
                        onDeleteColetaPrecoFornecedor={viewModel.handleDeleteColetaPrecoFornecedor}
                        onCancelarAprovacaoColetaPrecoFornecedorSubmit={viewModel.handleCancelarAprovacaoColetaPrecoFornecedorSubmit}
                        onConfigurarPagamentoSubmit={() => viewModel.handleConfigurarPagamentoModalOpenState(true)}
                      />
                    }
                  </div>
                </>
              )
          }
        </div>

        {/**
          * BottomBar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div className="flex flex-row gap-2 items-center">
              {
                isValidId(viewModel.idColetaPreco) &&
                <div>
                  <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                    <span className="text-xs">
                      Historico de alterações
                    </span>
                  </PrimaryButton>
                </div>
              }
              {
                (viewModel.idColetaPreco && viewModel.coletaPreco && viewModel.coletaPreco.status === 0) &&
                <div>
                  <PrimaryButton
                    buttonColor="secondary-orange"
                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                    onMouseDown={e => {
                      viewModel.handleNovoPopperActions(1);
                      e.preventDefault();
                    }}>
                    Incluir fornecedor para cotação
                  </PrimaryButton>
                </div>
              }
            </div>

            <div className="flex flex-row gap-4">
              {
                (viewModel.status === 3 || viewModel.status === 2) &&
                <div className="w-[12.5rem]">
                  <PrimaryButton
                    buttonColor="purple"
                    startIcon={<DynamicIcon nameIcon="LocalAtm" size={25} className="text-white" />}
                    onMouseDown={e => {
                      viewModel.handleConfigurarPagamentoModalOpenState(true);
                      e.preventDefault();
                    }}>
                    Configurar Pagamento
                  </PrimaryButton>
                </div>
              }

              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals
        */}

      <ColetaPrecoFornecedorModal
        open={viewModel.coletaPrecoFornecedorModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        fornecedoresDropdown={viewModel.fornecedoresDropdown}
        produtosServicosDropdown={viewModel.produtosServicosDropdown}
        onClose={() => viewModel.handleColetaPrecoFornecedorModalOpenState(false)}
        onSubmit={viewModel.handleColetaPrecoFornecedorSubmit}
        onNewFornecedor={viewModel.handleNewFornecedor}
      />

      <CopyColetaPrecoFornecedorModal
        open={viewModel.coletaPrecoFornecedorCopyModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        fornecedoresDropdown={viewModel.fornecedoresDropdown}
        onClose={() => viewModel.handleCopyColetaPrecoFornecedor(false)}
        onSubmit={viewModel.handleCopyColetaPrecoFornecedorSubmit}
      />

      <ConfigurarPagamentoModal
        open={viewModel.configurarPagamentoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        valorTotal={viewModel.total}
        coletaPreco={viewModel.coletaPreco}
        fornecedor={viewModel.coletaPrecoFornecedorAprovada}
        configurarPagamentoColeta={viewModel.configurarPagamentoColeta}
        onClose={() => viewModel.handleConfigurarPagamentoModalOpenState(false)}
        onSubmit={viewModel.handleConfigurarPagamentoSubmit}
        onDeleteConfigurarPagamentoSubmit={viewModel.handleDeleteConfigurarPagamentoSubmit}
      />

      <DeleteDialog
        open={viewModel.coletaPrecoDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleDeleteColetaPrecoOpenState(false)}
        onDelete={() => viewModel.handleDeleteColetaPrecoSubmit()}
      />

      <DeleteDialog
        open={viewModel.coletaPrecoFornecedorDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleDeleteColetaPrecoFornecedor(false)}
        onDelete={() => viewModel.handleDeleteColetaPrecoFornecedorSubmit()}
      />

      <FornecedorDrawer
        saving={viewModel.saving}
        state={viewModel.fornecedorStateDrawer}
        centrosCustoDropdown={viewModel.centroCustosDropdown}
      />

      <EmailModal
        state={viewModel.emailState}
        loading={viewModel.loading}
        onSubmit={viewModel.handleEmailAprovacaoSubmit}
      />

      <AprovadoresColetaPrecoModal
        open={false}
        saving={false}
        loading={false}
        onClose={() => { }}
        onSubmit={() => { }}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

    </>
  );
}